import { StyleSheet, Dimensions } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width } = Dimensions.get('window');
export default StyleSheet.create({
  container: {
    backgroundColor: Colors.transparent,
    width: 350,

    paddingBottom: 15,
  },
  text: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    lineHeight: 30,
  },
  descriptionContaienr: { flexDirection: 'row' },
  textContainer: {
    marginTop: 6.1,
    marginBottom: 25,
    width: 237,
  },
  stepImage: { width: 107, height: 107, position: 'absolute', right: -45 },

  buttonContainerStyle: {
    width: width * 0.75,
  },
  skippedbtn: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    marginTop: 16,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.brownGrey,
  }),
  textbutton1: {
    color: Colors.cardBackground,
    lineHeight: 24,
    fontSize: 18,
  },
  textbutton2: theme => ({
    color: theme.colors.textColorThree,
    lineHeight: 24,
    fontSize: 18,
  }),
});
